import React from 'react'
import cx from 'classnames'

import styles from './styles.module.scss'
import PromotionsManager from '@sweetspot/sweetspot-js/features/promotions/containers/PromotionsManager'
import { useSelector } from 'react-redux'

const PromotionsSettings = ({ membershipId, membershipType }) => {
  const clubId = useSelector((state) => state?.golfClub?.selectedId)

  return (
    <div className={cx(styles.container)}>
      <PromotionsManager
        context="membership"
        membershipId={membershipId}
        membershipType={membershipType}
        clubId={clubId}
        restrictWidth={false}
      />
    </div>
  )
}

export default PromotionsSettings
